<ng-container *mobxAutorun>
  <ns-header [enableCenterLayout]="true" [enableLogoutButton]="true"> </ns-header>
  <div
    class="body"
    [class.fit-content]="currentStep === 6 || currentStep === 7"
    [class.full-height]="currentStep === 7"
  >
    <ng-container *ngIf="currentStep === 0 && !loadingUser">
      <img src="assets/img/onboarding-1.png" />
      <ion-text color="primary" class="ion-text-center" *ngIf="userService.currentUser">
        <h1>
          {{
            'components.onboardingCarousel.titles.userWelcome'
              | translate: { name: userService.currentUser.firstName }
          }}
        </h1>
      </ion-text>
      <div class="ion-no-padding ly-col ion-align-items-center">
        <p
          id="intro-text"
          class="ion-text-center"
          [innerHTML]="'components.onboardingCarousel.titles.netsocial' | translate"
        ></p>
        <ion-button class="ion-margin-top" (click)="mutStep(1)">
          <ion-icon slot="start" src="assets/icon/atlas.svg" size="small"> </ion-icon>
          {{ 'components.onboardingCarousel.buttons.start' | translate }}
        </ion-button>
      </div>
    </ng-container>
    <ng-container *ngIf="currentStep === 1 && !loadingUser">
      <ion-text color="medium" class="ion-margin-bottom">
        <h1>
          {{ 'components.onboardingCarousel.titles.userEdit' | translate }}
        </h1>
      </ion-text>
      <div class="ly-col stretch-x ion-margin-top">
        <ion-label>{{ 'components.onboardingCarousel.titles.name' | translate }}</ion-label>
        <div class="ly-row ion-margin-vertical">
          <ion-col size="6" class="ion-no-padding">
            <ion-item class="ion-margin-end">
              <ion-input
                [placeholder]="
                  'components.onboardingCarousel.labels.firstNamePlaceholder' | translate
                "
                [value]="userToEdit!.firstName"
                (ionChange)="userToEdit!.firstName = $any($event).target.value"
              >
              </ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="6" class="ion-no-padding">
            <ion-item class="ion-margin-start">
              <ion-input
                [placeholder]="
                  'components.onboardingCarousel.labels.lastNamePlaceholder' | translate
                "
                [value]="userToEdit!.lastName"
                (ionChange)="userToEdit!.lastName = $any($event).target.value"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </div>
        <ion-label>{{ 'components.onboardingCarousel.titles.email' | translate }}</ion-label>
        <div class="ion-margin-vertical">
          <ion-item>
            <ion-input
              [placeholder]="'components.onboardingCarousel.labels.emailPlaceholder' | translate"
              [value]="userToEdit!.email"
              (ionChange)="userToEdit!.email = $any($event).target.value"
            >
            </ion-input>
          </ion-item>
        </div>
        <ion-label>
          {{ 'components.onboardingCarousel.titles.phone' | translate }}
        </ion-label>
        <div class="ion-margin-vertical">
          <ui-phone-input
            [value]="userToEdit!.phone"
            (ionChangePhoneNumber)="userToEdit!.phone = $event"
            (ionChangeCountry)="userToEdit!.country = $event"
            (ionChangeValidity)="validPhone = $event"
          >
          </ui-phone-input>
          <p>
            {{ validPhone === false ? ('errors.invalidPhone' | translate) : '' }}
          </p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="currentStep === 2 && !loadingUser">
      <ion-text color="medium" class="ion-margin-bottom">
        <h1>
          {{ 'components.onboardingCarousel.titles.passwordTitle' | translate }}
        </h1>
      </ion-text>
      <div class="ly-col stretch-x ion-margin-top">
        <div class="ion-padding">
          <div class="ion-margin-bottom">
            <ion-label>{{
              'workspace.settings.changePassword.labels.password' | translate
            }}</ion-label>
            <ion-item class="ion-margin-top">
              <ion-input
                required="true"
                type="password"
                (ionChange)="userToEdit!.password = $any($event).target.value"
              ></ion-input>
            </ion-item>
            <password-strength-meter
              (strengthChange)="passwordStrengthChange($event)"
              [password]="userToEdit!.password"
              [enableFeedback]="true"
            >
            </password-strength-meter>
          </div>
          <ion-label>
            {{ 'workspace.settings.changePassword.labels.verifyPassword' | translate }}
          </ion-label>
          <ion-item class="ion-margin-top">
            <ion-input
              required="true"
              type="password"
              autocomplete="off"
              (ionChange)="userToEdit!.verifyPassword = $any($event).target.value"
              [value]="userToEdit!.verifyPassword"
            >
            </ion-input>
          </ion-item>
          <p
            *ngIf="
              userToEdit!.verifyPassword && userToEdit!.password !== userToEdit!.verifyPassword
            "
            class="md-input-error"
            [innerHTML]="'errors.passwordMatch' | translate"
          ></p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="currentStep === 3 && !loadingUser">
      <ion-text color="medium" class="ion-margin-bottom notification-title">
        <h1>
          {{ 'components.onboardingCarousel.titles.notificationEdit' | translate }}
        </h1>
      </ion-text>
      <div
        class="ion-padding-bottom ion-margin-bottom notification-container stretch-x"
        [class.ly-col]="isDesktop"
        [style.overflow]="!isDesktop ? 'scroll' : undefined"
      >
        <div class="ly-col" *ngFor="let type of ['alert', 'approval', 'info']">
          <h3>
            {{ 'components.onboardingCarousel.titles.' + type | translate }}
          </h3>
          <div
            class="alert-row ion-align-items-center ly-row ion-justify-content-between notification-group"
          >
            <p class="ion-no-margin ion-padding-end inline-text">
              {{ 'components.onboardingCarousel.titles.' + type + 'Description' | translate }}
            </p>
            <ion-card>
              <p class="ion-no-margin ion-padding-end">
                {{ 'components.onboardingCarousel.labels.emailLabel' | translate }}s
              </p>
              <ion-toggle
                mode="ios"
                color="secondary"
                [checked]="$any(userToEdit!.notificationPreferences.emailNum)[type]"
                (ionChange)="
                  $any(userToEdit!.notificationPreferences.email)[type] =
                    $any(userToEdit!.notificationPreferences.emailNum)[type] === '0' ? '1' : '0'
                "
              ></ion-toggle>
            </ion-card>

            <ion-card>
              <p class="ion-no-margin ion-padding-end">
                {{ 'components.onboardingCarousel.labels.textLabel' | translate }}
              </p>
              <ion-toggle
                [checked]="$any(userToEdit!.notificationPreferences.smsNum)[type]"
                (ionChange)="
                  $any(userToEdit!.notificationPreferences.sms)[type] =
                    $any(userToEdit!.notificationPreferences.smsNum)[type] === '0' ? '1' : '0'
                "
                color="secondary"
                mode="ios"
              >
              </ion-toggle>
            </ion-card>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="currentStep === 4">
      <ion-text color="medium" class="ion-margin-bottom ion-text-center">
        <h1 *ngIf="didLoadAccounts">
          {{
            'components.onboardingCarousel.titles.' +
              (accounts && accounts.length ? 'alreadyConnected' : 'socialConnect') | translate
          }}
        </h1>
        <p *ngIf="didLoadAccounts">
          {{ 'components.onboardingCarousel.titles.sharingToAccounts' | translate }}
        </p>
        <ion-skeleton-text *ngIf="!didLoadAccounts"></ion-skeleton-text>
        <account-connect
          [showAccounts]="true"
          [showTitles]="true"
          [slim]="true"
          (ionAccountsLoaded)="accountsLoaded($event)"
        >
        </account-connect>
      </ion-text>
    </ng-container>
    <ng-container *ngIf="currentStep === 5">
      <ion-text color="medium" class="ion-margin-bottom channel-description-title">
        <h1>
          {{ 'components.onboardingCarousel.titles.channelExplain1' | translate }}
          <br />
          {{ 'components.onboardingCarousel.titles.channelExplain2' | translate }}
        </h1>
      </ion-text>
      <div>
        <ion-row *ngFor="let type of ['explainChannel', 'explainFunction', 'explainSharing']">
          <ion-icon name="checkmark-circle" color="primary" size="large" class="ion-margin-end">
          </ion-icon>
          <ion-col>
            <h3 class="ion-no-margin">
              {{ 'components.onboardingCarousel.titles.' + type | translate }}
            </h3>
            <p>
              {{ 'components.onboardingCarousel.titles.' + type + 'Description' | translate }}
            </p>
            <p *ngIf="type === 'explainChannel'">
              {{ 'components.onboardingCarousel.titles.' + type + 'Description2' | translate }}
            </p>
          </ion-col>
        </ion-row>
      </div>
    </ng-container>
    <ng-container *ngIf="currentStep === 6">
      <ion-text color="medium" class="ion-margin-bottom channel-description-title">
        <h1>
          {{ 'components.onboardingCarousel.titles.addChannel' | translate }}
        </h1>

        <p>
          {{ 'components.onboardingCarousel.titles.explainAddChannel' | translate }}
        </p>
      </ion-text>
      <edit-channel
        #editChannel
        class="full-width"
        [hideFooter]="true"
        [channel]="onboardingChannel || undefined"
      >
      </edit-channel>
    </ng-container>
    <ng-container *ngIf="currentStep === 7">
      <ion-text color="medium" class="ion-margin-bottom ion-text-center">
        <h1>
          {{ 'components.onboardingCarousel.titles.addContentChannels' | translate }}
        </h1>
      </ion-text>
      <channel-dashboard
        [search]="search"
        [hideManagement]="true"
        [hidePipeline]="true"
        [showInvited]="true"
      >
      </channel-dashboard>
    </ng-container>
    <ng-container *ngIf="currentStep === 9">
      <ion-text color="medium" class="ion-margin-bottom stretch-x">
        <h1>
          {{ 'components.onboardingCarousel.titles.addAccountChannels' | translate }}
        </h1>
      </ion-text>
      <ion-row class="stretch-x account-container">
        <ion-item
          [color]="
            didLoadAccounts && selectedAccount && selectedAccount.id === account.id
              ? 'primary'
              : undefined
          "
          [button]="true"
          [disabled]="!didLoadAccounts"
          (click)="accountIndex = i"
          class="shadow account-chip ion-margin-end"
          *ngFor="let account of $any(didLoadAccounts ? accounts : ['', '', '']); let i = index"
        >
          <entity-avatar *ngIf="didLoadAccounts" [entity]="account"> </entity-avatar>

          <ion-avatar slot="start" *ngIf="!didLoadAccounts">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-avatar>

          <ion-label *ngIf="didLoadAccounts">
            {{ account?.formattedLabel }}
          </ion-label>
          <ion-skeleton-text *ngIf="!didLoadAccounts" style="width: 100px"> </ion-skeleton-text>
        </ion-item>
      </ion-row>
      <channel-dashboard
        [hideManagement]="true"
        [hidePipeline]="true"
        [hideChannelCategories]="true"
        [selectable]="true"
        [accountToAdd]="selectedAccount"
        [hideChannelAdd]="true"
        [overflow]="true"
      >
      </channel-dashboard>
    </ng-container>
  </div>
  <ion-row
    class="ion-padding-vertical actions"
    [class.ion-justify-content-between]="isDesktop"
    *ngIf="currentStep !== 0"
    [style.display]="isDesktop ? 'flex' : 'block'"
  >
    <ion-row *ngIf="!isDesktop" [style.justifyContent]="'space-between'" [style.display]="'flex'">
      <ion-button (click)="mutStep(currentStep - 1)" [disabled]="loadingSave">
        {{ 'backText' | translate }}
      </ion-button>
      <ion-button *ngIf="currentStep === 6" (click)="checkChannel(currentStep + 1)">
        <ng-container *ngIf="!loadingSave">
          {{ 'addText' | translate }}
        </ng-container>
        <ion-spinner name="dots" *ngIf="loadingSave"> </ion-spinner>
      </ion-button>

      <ion-button (click)="mutStep(currentStep + 1)" [disabled]="nextDisabled">
        <ng-container *ngIf="!loadingSave">
          {{ 'nextText' | translate }}
        </ng-container>
        <ion-spinner name="dots" *ngIf="loadingSave"> </ion-spinner>
      </ion-button>
    </ion-row>
    <ion-button (click)="mutStep(currentStep - 1)" [disabled]="loadingSave" *ngIf="isDesktop">
      {{ 'backText' | translate }}
    </ion-button>

    <ion-row
      class="ion-align-items-center"
      [style.display]="isDesktop ? undefined : 'flex'"
      [style.justifyContent]="isDesktop ? undefined : 'center'"
      [class.ion-padding-top]="!isDesktop"
    >
      <div
        class="md-status-circle {{ i === currentStep - 1 ? 'primary' : 'medium' }}"
        *ngFor="let a of ['', '', '', '', '', '']; let i = index"
      ></div>
    </ion-row>

    <ion-button *ngIf="currentStep === 6 && isDesktop" (click)="checkChannel(currentStep + 1)">
      <ng-container *ngIf="!loadingSave">
        {{ 'addText' | translate }}
      </ng-container>
      <ion-spinner name="dots" *ngIf="loadingSave"> </ion-spinner>
    </ion-button>

    <ion-button (click)="mutStep(currentStep + 1)" [disabled]="nextDisabled" *ngIf="isDesktop">
      <ng-container *ngIf="!loadingSave">
        {{ 'nextText' | translate }}
      </ng-container>
      <ion-spinner name="dots" *ngIf="loadingSave"> </ion-spinner>
    </ion-button>
  </ion-row>
</ng-container>
